/* =========================================================
   Aether Rift — theme scripts (no dependencies)
   ========================================================= */
(function () {
  'use strict';

  const AR = window.AetherRift || { routes: {}, strings: {} };
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const root = (AR.routes.root || '/').replace(/\/$/, '');

  /* ---------- storage (fails quietly in private mode) ---------- */
  const store = {
    get(key, fallback) {
      try { const v = localStorage.getItem('ar:' + key); return v === null ? fallback : JSON.parse(v); }
      catch (e) { return fallback; }
    },
    set(key, value) { try { localStorage.setItem('ar:' + key, JSON.stringify(value)); } catch (e) { /* ignore */ } }
  };

  async function runPool(items, size, fn) {
    const results = []; let i = 0;
    const workers = Array.from({ length: Math.min(size, items.length) }, async () => {
      while (i < items.length) { const idx = i++; results[idx] = await fn(items[idx], idx); }
    });
    await Promise.all(workers);
    return results;
  }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    const fmt = AR.moneyFormat || '${{amount}}';
    const value = (Number(cents) || 0) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      if (key === 'amount_no_decimals') return Math.round(value).toLocaleString('en-US');
      if (key === 'amount_with_comma_separator') return value.toFixed(2).replace('.', ',');
      return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  /* ---------- toast ---------- */
  let toastTimer;
  function toast(message, isError) {
    const el = $('#RiftToast');
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  }

  /* ---------- cart ---------- */
  async function refreshCartCount() {
    try {
      const res = await fetch(root + '/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      return cart;
    } catch (e) { return null; }
  }

  async function addToCart(items) {
    const res = await fetch(root + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || AR.strings.error);
    await refreshCartCount();
    return data;
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-ajax-add]');
    if (!form) return;
    event.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const fd = new FormData(form);
    const id = Number(fd.get('id'));
    const quantity = Number(fd.get('quantity') || 1);
    if (!id) return;
    if (btn) btn.setAttribute('aria-disabled', 'true');
    try {
      await addToCart([{ id, quantity }]);
      if (AR.cart && AR.cart.drawer && AR.cart.openOnAdd && $('[data-cart-drawer]')) openCart();
      else toast(AR.strings.added || 'Added to cart');
      if (btn) { btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1200); }
    } catch (err) {
      toast(err.message, true);
    } finally {
      if (btn) btn.removeAttribute('aria-disabled');
    }
  });


  /* ---------- cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  function renderCart(cart) {
    if (!drawer || !cart) return;
    const lines = $('[data-cart-lines]', drawer);
    $('[data-cart-drawer-count]', drawer).textContent = cart.item_count ? `(${cart.item_count})` : '';
    $('[data-cart-subtotal]', drawer).textContent = formatMoney(cart.total_price);
    $('[data-cart-foot]', drawer).hidden = cart.item_count === 0;
    const goal = (AR.cart && AR.cart.freeShipping) || 0;
    const ship = $('[data-cart-ship]', drawer);
    if (goal > 0 && cart.item_count > 0) {
      const left = goal - cart.total_price;
      ship.hidden = false;
      $('[data-cart-ship-text]', drawer).innerHTML = left > 0 ? `You're <strong>${formatMoney(left)}</strong> away from <strong>free shipping</strong>.` : '<strong>You unlocked free shipping!</strong> ✨';
      $('[data-cart-ship-bar]', drawer).style.width = Math.min(100, (cart.total_price / goal) * 100) + '%';
    } else ship.hidden = true;
    if (!cart.items.length) {
      lines.innerHTML = `<div class="drawer__empty"><p class="muted">${escapeHtml((AR.strings && AR.strings.empty) || 'Your cart is empty. The rift awaits.')}</p><a class="btn btn--primary" href="${(AR.finder && AR.finder.search) || '/search'}">Search cards</a></div>`;
      return;
    }
    lines.innerHTML = cart.items.map((it) => {
      const img = it.image ? `<img src="${it.image}${it.image.includes('?') ? '&' : '?'}width=140" alt="" loading="lazy">` : '<span></span>';
      const opts = (it.options_with_values || []).filter((o) => o.value !== 'Default Title').map((o) => o.value).join(' · ');
      return `<div class="cline" data-key="${it.key}">
        <a href="${it.url}">${img}</a>
        <div><a class="cline__title" href="${it.url}">${escapeHtml(it.product_title)}</a>${opts ? `<div class="cline__meta">${escapeHtml(opts)}</div>` : ''}
          <div class="cline__qty"><button type="button" data-cart-qty="-1" aria-label="Decrease">−</button><span>${it.quantity}</span><button type="button" data-cart-qty="1" aria-label="Increase">+</button></div></div>
        <div class="cline__right"><span class="price">${formatMoney(it.final_line_price)}</span><button type="button" class="cline__remove" data-cart-remove>Remove</button></div>
      </div>`;
    }).join('');
  }
  async function changeLine(key, quantity) {
    drawer.classList.add('is-busy');
    try {
      const res = await fetch(root + '/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const cart = await res.json();
      if (!res.ok) throw new Error(cart.description || cart.message || AR.strings.error);
      renderCart(cart);
      $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    } catch (err) { toast(err.message, true); await openCart(); } finally { drawer.classList.remove('is-busy'); }
  }
  let lastFocus = null;
  async function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    document.body.classList.add('no-scroll');
    renderCart(await refreshCartCount());
    const close = $('[data-cart-close].icon-btn', drawer);
    if (close) close.focus();
  }
  function closeCart() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(() => { drawer.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer) {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href$="/cart"], a[href="/cart"], [data-open-cart]');
      if (link && !link.closest('[data-cart-drawer]') && !(e.metaKey || e.ctrlKey)) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
      const line = e.target.closest('.cline');
      if (!line) return;
      if (e.target.closest('[data-cart-remove]')) changeLine(line.dataset.key, 0);
      const q = e.target.closest('[data-cart-qty]');
      if (q) changeLine(line.dataset.key, Math.max(0, Number($('.cline__qty span', line).textContent) + Number(q.dataset.cartQty)));
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });
  }

  /* ---------- header toggles ---------- */
  function bindToggle(btnSel, targetSel, focusSel) {
    $$(btnSel).forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = $(targetSel);
        if (!target) return;
        const open = !target.classList.contains('is-open');
        target.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
        if (open && focusSel) { const f = $(focusSel, target); if (f) f.focus(); }
      });
    });
  }
  bindToggle('.js-menu-toggle', '#MobileNav');
  /* category bar dropdowns: click/tap to open, Escape or outside click to close */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.catbar__item.has-dropdown > .catbar__link');
    $$('.catbar__item.is-open').forEach((li) => { if (!btn || li !== btn.parentElement) { li.classList.remove('is-open'); const b = $('.catbar__link', li); if (b) b.setAttribute('aria-expanded', 'false'); } });
    if (btn) { const li = btn.parentElement; const open = li.classList.toggle('is-open'); btn.setAttribute('aria-expanded', String(open)); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('.catbar__item.is-open').forEach((li) => li.classList.remove('is-open'));
    $$('.fbar__item[open]').forEach((d) => { d.open = false; });
  });

  /* filter bar: one popover at a time, close on outside click, find-in-list */
  document.addEventListener('click', (e) => {
    const inside = e.target.closest('.fbar__item');
    $$('.fbar__item[open]').forEach((d) => { if (d !== inside) d.open = false; });
  });
  document.addEventListener('input', (e) => {
    if (!e.target.matches('[data-fbar-find]')) return;
    const q = e.target.value.trim().toLowerCase();
    $$('[data-fbar-value]', e.target.parentElement).forEach((li) => { li.hidden = q && !li.dataset.fbarValue.includes(q); });
  });
  document.addEventListener('change', (e) => {
    const t = e.target.closest('.fbar__toggle');
    if (t) t.classList.toggle('is-active', e.target.checked);
  }, true);
  bindToggle('.js-facets-toggle', '#Facets');

  /* ---------- predictive search ---------- */
  function bindPredictive(scope = document) {
  $$('[data-predictive-search]', scope).forEach((form) => {
    if (form.dataset.psBound) return;
    form.dataset.psBound = '1';
    const input = $('input[type="search"]', form);
    const box = $('[data-predictive-results]', form);
    if (!input || !box) return;
    let timer, controller;
    input.addEventListener('focus', () => { if (window.RiftFinder) window.RiftFinder.loadAll().catch(() => {}); }, { once: true });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { box.hidden = true; return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      const links = $$('a', box); if (!links.length || box.hidden) return;
      e.preventDefault();
      const i = links.indexOf(document.activeElement);
      (links[e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : Math.max(0, i - 1)]).focus();
    });
    box.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      e.preventDefault();
      const links = $$('a', box); const i = links.indexOf(document.activeElement);
      if (e.key === 'ArrowUp' && i <= 0) { input.focus(); return; }
      (links[e.key === 'ArrowDown' ? Math.min(links.length - 1, i + 1) : i - 1]).focus();
    });
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { box.hidden = true; return; }
      timer = setTimeout(async () => {
        const RF = window.RiftFinder;
        if (RF && AR.finder) {
          try {
            const items = await RF.loadAll();
            if (input.value.trim() !== q) return;
            box.innerHTML = RF.suggestHTML(items, q, AR.finder.search || '/search');
            box.hidden = false;
            return;
          } catch (err) { /* fall back to Shopify's predictive search */ }
        }
        if (controller) controller.abort();
        controller = new AbortController();
        const params = new URLSearchParams({
          q,
          'resources[type]': 'product,collection',
          'resources[limit]': '8',
          'resources[options][fields]': 'title,product_type,variants.sku,tag,vendor',
          'resources[options][unavailable_products]': 'last'
        });
        try {
          const res = await fetch((AR.routes.predictive_search || root + '/search/suggest') + '.json?' + params, { signal: controller.signal });
          const data = await res.json();
          const r = (data.resources && data.resources.results) || {};
          const cols = (r.collections || []).slice(0, 3).map((c) => `<a class="predictive__item" href="${c.url}"><span class="badge badge--rarity">Set</span><span>${escapeHtml(c.title)}</span><span></span></a>`);
          const toks = normText(q).split(' ').filter((t) => t.length > 1);
          const prods = (r.products || []).filter((p) => {
            const hay = normText([p.title, p.type, p.vendor, (p.tags || []).join(' '), (p.variants || []).map((v) => v.sku).join(' ')].join(' '));
            return toks.every((t, i) => (i === toks.length - 1 ? new RegExp('(^| )' + t).test(hay) : hay.includes(t)));
          }).map((p) => {
            const img = p.featured_image && p.featured_image.url ? `<img src="${p.featured_image.url}&width=88" alt="" loading="lazy">` : '<span></span>';
            return `<a class="predictive__item" href="${p.url}">${img}<span>${escapeHtml(p.title)}${p.available ? '' : ' <small class="muted">— ' + (AR.strings.soldOut || 'Sold out') + '</small>'}</span><span class="price">${p.price ? escapeHtml(formatMoney(Math.round(parseFloat(p.price) * 100))) : ''}</span></a>`;
          });
          const html = cols.concat(prods).join('');
          box.innerHTML = (html || '<p class="muted" style="padding:.5rem">No cards match. Press Enter to search anyway.</p>') + (prods.length ? `<a class="predictive__all" href="${form.action}?type=product&q=${encodeURIComponent(q)}">See all results for “${escapeHtml(q)}” →</a>` : '');
          box.hidden = false;
        } catch (e) { /* aborted or offline */ }
      }, 220);
    });
    document.addEventListener('click', (e) => { if (!form.contains(e.target)) box.hidden = true; });
  });
  }
  bindPredictive();

  function normText(str) {
    return String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }

  /* ---------- sticky offset for the Finder toolbar ---------- */
  const hdr = $('.site-header');
  const setHeaderH = () => { if (hdr) document.documentElement.style.setProperty('--header-h', hdr.offsetHeight + 'px'); };
  setHeaderH(); window.addEventListener('resize', setHeaderH);

  /* ---------- holo tilt ---------- */
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function bindTilt(el, img) {
    if (reduceMotion || !img) return;
    el.addEventListener('pointermove', (e) => {
      const r = el.getBoundingClientRect();
      const x = (e.clientX - r.left) / r.width;
      const y = (e.clientY - r.top) / r.height;
      img.style.transform = `rotateY(${(x - 0.5) * 14}deg) rotateX(${(0.5 - y) * 14}deg) scale(1.03)`;
      el.style.setProperty('--mx', (x * 100) + '%');
      el.style.setProperty('--my', (y * 100) + '%');
    });
    el.addEventListener('pointerleave', () => { img.style.transform = ''; });
  }
  function initTilt(scope = document) {
    $$('.card[data-tilt]', scope).forEach((card) => {
      if (card.dataset.tiltBound) return;
      card.dataset.tiltBound = '1';
      bindTilt(card, $('.card__media img', card));
    });
  }
  initTilt();
  window.AetherRiftUI = { initTilt: (scope) => initTilt(scope || document), openCart: () => openCart(), closeCart: () => closeCart() };
  $$('[data-stage-tilt]').forEach((stage) => bindTilt(stage, $('img', stage)));

  /* ---------- countdowns ---------- */
  function tickCountdowns() {
    const now = Date.now();
    $$('[data-countdown]').forEach((el) => {
      const target = Date.parse(el.dataset.countdown);
      if (isNaN(target)) return;
      let diff = Math.max(0, target - now);
      if (diff === 0) {
        el.innerHTML = '<span>' + (el.dataset.liveLabel || 'Out now') + '</span>';
        const row = el.closest('.release');
        if (row) row.classList.add('is-live');
        return;
      }
      const d = Math.floor(diff / 864e5); diff -= d * 864e5;
      const h = Math.floor(diff / 36e5); diff -= h * 36e5;
      const m = Math.floor(diff / 6e4); diff -= m * 6e4;
      const s = Math.floor(diff / 1e3);
      el.innerHTML = `<span>${d}<small>d</small></span><span>${h}<small>h</small></span><span>${m}<small>m</small></span><span>${s}<small>s</small></span>`;
    });
  }
  if ($('[data-countdown]')) { tickCountdowns(); setInterval(tickCountdowns, 1000); }

  /* ---------- collection: ajax filtering ---------- */
  function initCollection(scope = document) {
    const container = $('[data-collection]', scope);
    if (!container) return;
    const sectionId = container.dataset.sectionId;

    async function render(url, push = true) {
      const grid = $('[data-collection]');
      grid.classList.add('is-loading');
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      try {
        const res = await fetch(u.toString());
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        $$('[data-ajax-region]').forEach((region) => {
          const fresh = doc.querySelector(`[data-ajax-region="${region.dataset.ajaxRegion}"]`);
          if (!fresh) return;
          if (region.classList.contains('is-open')) fresh.classList.add('is-open');
          $$('details', region).forEach((d, i) => { const fd = $$('details', fresh)[i]; if (fd) fd.open = d.open; });
          region.replaceWith(fresh);
        });
        u.searchParams.delete('section_id');
        if (push) history.pushState({}, '', u.pathname + u.search);
        afterRender();
      } catch (e) {
        window.location.href = url;
      } finally {
        const g = $('[data-collection]');
        if (g) g.classList.remove('is-loading');
      }
    }

    function urlFromForm(form) {
      const fd = new FormData(form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) { if (v !== '') params.append(k, v); }
      const sort = $('[data-sort-by]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      return window.location.pathname + '?' + params.toString();
    }

    let debounce;
    document.addEventListener('change', (e) => {
      const form = e.target.closest('[data-facets-form]');
      if (form && !e.target.matches('[data-fbar-find]')) {
        clearTimeout(debounce);
        debounce = setTimeout(() => render(urlFromForm(form)), e.target.type === 'number' ? 600 : 50);
        return;
      }
      if (e.target.matches('[data-sort-by]')) {
        const f = $('[data-facets-form]');
        if (f) render(urlFromForm(f));
        else { const u = new URL(window.location.href); u.searchParams.set('sort_by', e.target.value); render(u.toString()); }
      }
    });

    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-facet-link], .pagination a');
      if (!link || !$('[data-collection]')) return;
      e.preventDefault();
      render(link.href);
      if (link.closest('.pagination')) window.scrollTo({ top: ($('[data-collection]').getBoundingClientRect().top + window.scrollY) - 120, behavior: 'smooth' });
    });

    window.addEventListener('popstate', () => render(window.location.href, false));
    afterRender();
  }

  /* ---------- views, page-sort, set checklist ---------- */
  const RARITY_RANK = {
    'common': 1, 'c': 1, 'uncommon': 2, 'u': 2, 'rare': 3, 'r': 3, 'holo rare': 4, 'rare holo': 4,
    'double rare': 5, 'rr': 5, 'super rare': 5, 'sr': 6, 'ace spec rare': 6, 'mythic': 6, 'mythic rare': 6, 'm': 6,
    'leader': 5, 'l': 5, 'epic': 5, 'legendary': 6, 'ultra rare': 7, 'ur': 7, 'illustration rare': 7, 'ir': 7,
    'secret rare': 8, 'sec': 8, 'special illustration rare': 9, 'sir': 9, 'alternate art': 9, 'alt art': 9, 'manga': 10,
    'hyper rare': 10, 'hr': 10, 'lr': 9, 'legend rare': 9, 'sr★': 7, 'sr*': 7, 'ssr': 7, 'ur': 7, 'sgr': 8, 'lsr': 9, 'sc': 9, 'xr': 10, 'zr': 10, 'scr': 10, 'enchanted': 10, 'showcase': 8, 'promo': 4, 'p': 4
  };
  const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

  function sortList(list, mode) {
    const items = $$(':scope > [data-item]', list);
    const key = {
      number: (el) => el.dataset.number || '~',
      rarity: (el) => -(RARITY_RANK[(el.dataset.rarity || '').toLowerCase()] || 0),
      name: (el) => el.dataset.name || '',
      'price-asc': (el) => Number(el.dataset.price || 0),
      'price-desc': (el) => -Number(el.dataset.price || 0),
      set: (el) => (el.dataset.set || '') + ' ' + (el.dataset.number || '')
    }[mode];
    if (!key) return;
    items.sort((a, b) => {
      const ka = key(a), kb = key(b);
      return typeof ka === 'number' ? ka - kb : collator.compare(ka, kb);
    }).forEach((el) => list.appendChild(el));
  }

  function updateChecklist(list) {
    const setKey = list.dataset.setKey;
    if (!setKey) return;
    const owned = store.get('owned:' + setKey, []);
    let ownedCount = 0;
    $$(':scope > [data-item]', list).forEach((el) => {
      const is = owned.includes(el.dataset.productId);
      el.classList.toggle('is-owned', is);
      const cb = $('.owned-toggle input', el);
      if (cb) cb.checked = is;
      if (is) ownedCount++;
    });
    const total = Number(list.dataset.setTotal || 0);
    $$('[data-owned-count]').forEach((el) => { el.textContent = ownedCount; });
    $$('[data-owned-bar]').forEach((el) => {
      el.style.width = total ? Math.min(100, (ownedCount / total) * 100) + '%' : '0%';
    });
  }

  function afterRender() {
    const list = $('.product-list');
    initTilt();
    bindPredictive();
    if (!list) return;
    const view = store.get('view:' + (list.dataset.viewScope || 'cards'), list.dataset.view || 'grid');
    setView(list, view);
    const ps = $('[data-page-sort]');
    if (ps && ps.value) sortList(list, ps.value);
    updateChecklist(list);
    const hideOwned = $('[data-hide-owned]');
    if (hideOwned) list.classList.toggle('hide-owned', hideOwned.checked);
    initRefine();
  }

  function setView(list, view) {
    if (!$(`[data-view-btn="${view}"]`)) view = 'grid';
    list.dataset.view = view;
    $$('[data-view-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.viewBtn === view)));
    $$('[data-checklist-only]').forEach((el) => { el.hidden = view !== 'checklist'; });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-view-btn]');
    if (!btn) return;
    const list = $('.product-list');
    if (!list) return;
    setView(list, btn.dataset.viewBtn);
    store.set('view:' + (list.dataset.viewScope || 'cards'), btn.dataset.viewBtn);
    if (btn.dataset.viewBtn === 'checklist') { const ps = $('[data-page-sort]'); if (ps) { ps.value = 'number'; sortList(list, 'number'); } }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-page-sort]')) {
      const list = $('.product-list');
      if (list) sortList(list, e.target.value);
    }
    if (e.target.matches('.owned-toggle input')) {
      const list = e.target.closest('.product-list');
      const item = e.target.closest('[data-item]');
      if (!list || !item) return;
      const key = 'owned:' + list.dataset.setKey;
      const owned = new Set(store.get(key, []));
      if (e.target.checked) owned.add(item.dataset.productId); else owned.delete(item.dataset.productId);
      store.set(key, Array.from(owned));
      updateChecklist(list);
    }
    if (e.target.matches('[data-hide-owned]')) {
      const list = $('.product-list');
      if (list) list.classList.toggle('hide-owned', e.target.checked);
    }
  });

  initCollection();
  if (!$('[data-collection]')) afterRender();

  /* ---------- game tiles: fill with that game's 3 priciest in-stock cards ---------- */
  (function fillPortals() {
    const tiles = $$('[data-portal-src]');
    if (!tiles.length) return;
    const load = async (tile) => {
      const fan = $('.portal__fan', tile);
      if (!fan || fan.dataset.done) return;
      fan.dataset.done = '1';
      try {
        const u = new URL(tile.dataset.portalSrc, window.location.origin);
        u.searchParams.set('sort_by', 'price-descending');
        u.searchParams.set('filter.v.availability', '1');
        const html = await (await fetch(u.toString())).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const imgs = $$('.product-list [data-item] .card__media img', doc).slice(0, 3);
        if (!imgs.length) return;
        const order = [imgs[1], imgs[2], imgs[0]].filter(Boolean);
        fan.innerHTML = order.map((im) => {
          const src = (im.getAttribute('src') || '').replace(/([?&])width=\d+/, '$1width=360');
          return `<img src="${src}" alt="" loading="lazy">`;
        }).join('');
        const els = $$('img', fan);
        let left = els.length;
        els.forEach((img) => { const done = () => { if (--left <= 0) fan.classList.add('is-ready'); }; img.addEventListener('load', done); img.addEventListener('error', () => { img.remove(); done(); }); });
      } catch (e) { /* keep the gradient */ }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { io.unobserve(en.target); load(en.target); } }), { rootMargin: '200px' });
      tiles.forEach((t) => io.observe(t));
    } else tiles.forEach(load);
  })();

  /* ---------- new releases: load newest products ---------- */
  $$('[data-newest]').forEach(async (box) => {
    try {
      const html = await (await fetch(box.dataset.src)).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const items = $$('.product-list > [data-item]', doc).slice(0, Number(box.dataset.limit || 12));
      if (!items.length) { box.closest('section').hidden = true; return; }
      box.innerHTML = '';
      items.forEach((el) => box.appendChild(document.importNode(el, true)));
      initTilt(box);
    } catch (e) { box.closest('section').hidden = true; }
  });

  /* ---------- deal of the day countdown ---------- */
  $$('[data-deal-countdown]').forEach((el) => {
    const tz = el.dataset.tz || 'America/Chicago';
    const partsIn = (date) => {
      const f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      const o = {}; f.formatToParts(date).forEach((p) => { o[p.type] = p.value; });
      return o;
    };
    const tzOffset = () => { const p = partsIn(new Date()); const asUTC = Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second); return asUTC - Date.now(); };
    let target = null;
    const m = (el.dataset.end || '').match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/);
    if (m) target = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)) - tzOffset();
    const tick = () => {
      let left;
      if (target) left = Math.max(0, target - Date.now());
      else { const p = partsIn(new Date()); left = (86400 - ((p.hour % 24) * 3600 + p.minute * 60 + +p.second)) * 1000; }
      if (target && left === 0) { el.innerHTML = '<span>Ended</span>'; return; }
      const h = Math.floor(left / 36e5), mi = Math.floor(left % 36e5 / 6e4), se = Math.floor(left % 6e4 / 1e3);
      el.innerHTML = `<span>${String(h).padStart(2, '0')}<small>h</small></span><span>${String(mi).padStart(2, '0')}<small>m</small></span><span>${String(se).padStart(2, '0')}<small>s</small></span>`;
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- search quick filters (no app needed) ---------- */
  function setCodeOf(el) {
    const m = (el.dataset.name || '').match(/\[\s*([^\]\-\s][^\]\-]*?)\s*-/);
    if (m) return m[1].trim().toUpperCase();
    return (el.dataset.set || '').trim();
  }

  async function initRefine() {
    const panel = $('[data-refine]');
    const list = $('.product-list');
    if (!panel || !list) return;
    const key = (() => { const u = new URL(window.location.href); u.searchParams.delete('page'); return u.toString(); })();
    if (panel.dataset.loadedFor === key && list.dataset.refineMerged) return;
    panel.dataset.loadedFor = key;

    const status = $('[data-refine-status]', panel);
    const selSet = $('[data-refine-set]', panel);
    const selType = $('[data-refine-type]', panel);
    const condBox = $('[data-refine-cond]', panel);
    const minIn = $('[data-refine-min]', panel);
    const maxIn = $('[data-refine-max]', panel);
    const stockIn = $('[data-refine-stock]', panel);
    const resetBtn = $('[data-refine-reset]', panel);
    const total = Number(panel.dataset.total || 0);
    const cap = Number(panel.dataset.cap || 600);

    // 1) gather every result (up to the cap) into this page so filters cover all of them
    const firstItems = $$(':scope > [data-item]', list);
    const perPage = Math.max(firstItems.length, 1);
    const want = Math.min(total, cap);
    const pages = Math.ceil(want / perPage);
    const current = Number(new URL(window.location.href).searchParams.get('page') || 1);
    if (pages > 1) {
      status.textContent = `Loading ${want} results…`;
      const seen = new Set(firstItems.map((el) => el.dataset.productId));
      const sectionId = panel.dataset.sectionId;
      const fetchPage = async (n) => {
        const u = new URL(window.location.href);
        u.searchParams.set('page', n);
        u.searchParams.set('section_id', sectionId);
        try {
          const html = await (await fetch(u.toString())).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return $$('.product-list > [data-item]', doc);
        } catch (e) { return []; }
      };
      const nums = [];
      for (let n = 1; n <= pages; n++) if (n !== current) nums.push(n);
      const batches = await runPool(nums, 4, fetchPage);
      // keep page order: pages before the current one go first
      const before = [], after = [];
      nums.forEach((n, i) => (n < current ? before : after).push(...batches[i]));
      const add = (els, prepend) => {
        const frag = document.createDocumentFragment();
        els.forEach((el) => { if (seen.has(el.dataset.productId)) return; seen.add(el.dataset.productId); frag.appendChild(document.importNode(el, true)); });
        if (prepend) list.insertBefore(frag, list.firstChild); else list.appendChild(frag);
      };
      add(before, true); add(after, false);
      const pag = $('.pagination', list.parentElement);
      if (pag) pag.hidden = true;
      initTilt(list);
    }
    list.dataset.refineMerged = '1';
    const items = $$(':scope > [data-item]', list);

    // 2) keep only real matches: every search word must appear in the card's
    //    title, set code, type, vendor (set name), tags or SKU. Shopify's search page
    //    also returns loosely "related" products; those are hidden unless asked for.
    const terms = new URL(window.location.href).searchParams.get('q') || '';
    const tokens = normText(terms).split(' ').filter((t) => t.length > 1);
    items.forEach((el) => {
      const hay = normText([el.dataset.name, el.dataset.type, el.dataset.vendor, (el.dataset.tags || '').replace(/\|/g, ' '), el.dataset.sku, el.dataset.set].join(' '));
      el.dataset.match = (!tokens.length || tokens.every((t) => hay.includes(t))) ? '1' : '0';
    });
    const matched = items.filter((el) => el.dataset.match === '1');
    const relatedCount = items.length - matched.length;
    let showRelated = matched.length === 0 && relatedCount > 0 && !tokens.length;

    let note = $('[data-related-note]');
    if (!note) {
      note = document.createElement('div');
      note.className = 'related-note';
      note.dataset.relatedNote = '';
      list.parentElement.insertBefore(note, list);
    }

    // 3) build options from what is actually in the (matching) results
    const count = (arr) => arr.reduce((m, v) => { if (v) m[v] = (m[v] || 0) + 1; return m; }, {});
    const conds = {};
    items.forEach((el) => {
      const codes = new Set($$('.card__conds .cond', el).map((c) => c.textContent.trim()));
      el.dataset.conds = Array.from(codes).join(',');
    });
    const order = ['NM', 'LP', 'MP', 'HP', 'DMG', 'Sealed'];
    const rank = (c) => { const i = order.indexOf(c); return i === -1 ? 99 : i; };
    const opt = (obj) => Object.keys(obj).sort(collator.compare).map((k) => `<option value="${escapeHtml(k)}">${escapeHtml(k)} (${obj[k]})</option>`).join('');
    function buildOptions() {
      const base = showRelated ? items : matched;
      const sets = count(base.map(setCodeOf));
      const types = count(base.map((el) => el.dataset.type));
      Object.keys(conds).forEach((k) => delete conds[k]);
      base.forEach((el) => (el.dataset.conds || '').split(',').filter(Boolean).forEach((c) => { conds[c] = (conds[c] || 0) + 1; }));
      const keepSet = selSet.value, keepType = selType.value;
      selSet.innerHTML = '<option value="">All sets</option>' + opt(sets);
      selType.innerHTML = '<option value="">All games / types</option>' + opt(types);
      if (sets[keepSet]) selSet.value = keepSet;
      if (types[keepType]) selType.value = keepType;
      selSet.closest('.refine__field').hidden = Object.keys(sets).length < 2;
      selType.closest('.refine__field').hidden = Object.keys(types).length < 2;
      const picked = $$('[data-cond][aria-pressed="true"]', condBox).map((b) => b.dataset.cond);
      const condKeys = Object.keys(conds).sort((x, y) => rank(x) - rank(y));
      condBox.innerHTML = condKeys.map((c) => `<button type="button" class="chip${picked.includes(c) ? ' is-active' : ''}" data-cond="${escapeHtml(c)}" aria-pressed="${picked.includes(c)}">${escapeHtml(c)} <span class="muted">${conds[c]}</span></button>`).join('');
      condBox.closest('.refine__field').hidden = condKeys.length < 2;
    }
    buildOptions();

    // 4) filter
    function apply() {
      const set = selSet.value, type = selType.value;
      const pickedConds = $$('[data-cond][aria-pressed="true"]', condBox).map((b) => b.dataset.cond);
      const min = minIn.value === '' ? null : Number(minIn.value) * 100;
      const max = maxIn.value === '' ? null : Number(maxIn.value) * 100;
      let shown = 0;
      items.forEach((el) => {
        const price = Number(el.dataset.price || 0);
        const ok = (showRelated || el.dataset.match === '1')
          && (!set || setCodeOf(el) === set)
          && (!type || el.dataset.type === type)
          && (!pickedConds.length || pickedConds.some((c) => (el.dataset.conds || '').split(',').includes(c)))
          && (min === null || price >= min)
          && (max === null || price <= max)
          && (!stockIn.checked || el.dataset.available === 'true');
        el.hidden = !ok;
        if (ok) shown++;
      });
      const active = set || type || pickedConds.length || min !== null || max !== null || stockIn.checked;
      resetBtn.hidden = !active;
      const pool = showRelated ? items.length : matched.length;
      const capped = total > items.length ? ` (checked the first ${items.length} of ${total})` : '';
      status.textContent = active ? `Showing ${shown} of ${pool}${capped}` : `${pool} results ready to filter${capped}`;
      const countEl = $('[data-ajax-region="count"]');
      if (countEl) countEl.textContent = `${shown} result${shown === 1 ? '' : 's'}`;

      if (relatedCount > 0 && tokens.length) {
        const q = escapeHtml(terms);
        note.hidden = false;
        if (showRelated) {
          note.innerHTML = `Showing ${relatedCount} loosely related result${relatedCount === 1 ? '' : 's'} too. <button type="button" class="btn btn--ghost btn--small" data-related-toggle>Show exact matches only</button>`;
        } else if (matched.length === 0) {
          note.innerHTML = `<strong>No cards match “${q}”.</strong> Check the spelling or try a set code. <button type="button" class="btn btn--ghost btn--small" data-related-toggle>See ${relatedCount} related result${relatedCount === 1 ? '' : 's'}</button>`;
        } else {
          note.innerHTML = `Showing ${matched.length} match${matched.length === 1 ? '' : 'es'} for “${q}”. <button type="button" class="btn btn--ghost btn--small" data-related-toggle>Also show ${relatedCount} related</button>`;
        }
      } else {
        note.hidden = true;
      }
      const pag = $('.pagination', list.parentElement);
      if (pag) pag.hidden = true;
    }

    if (!note.dataset.bound) {
      note.dataset.bound = '1';
      note.addEventListener('click', (e) => {
        if (!e.target.closest('[data-related-toggle]')) return;
        showRelated = !showRelated;
        buildOptions();
        apply();
      });
    }

    if (!panel.dataset.bound) {
      panel.dataset.bound = '1';
      panel.addEventListener('change', apply);
      let t; panel.addEventListener('input', (e) => { if (e.target.type === 'number') { clearTimeout(t); t = setTimeout(apply, 300); } });
      panel.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-cond]');
        if (chip) { chip.setAttribute('aria-pressed', String(chip.getAttribute('aria-pressed') !== 'true')); chip.classList.toggle('is-active'); apply(); }
        if (e.target.closest('[data-refine-reset]')) {
          selSet.value = ''; selType.value = ''; minIn.value = ''; maxIn.value = ''; stockIn.checked = false;
          $$('[data-cond]', condBox).forEach((b) => { b.setAttribute('aria-pressed', 'false'); b.classList.remove('is-active'); });
          apply();
        }
      });
    }
    apply();
  }


  /* ---------- product tabs by game ---------- */
  $$('[data-ptabs]').forEach((sec) => {
    const row = $('[data-ptabs-row]', sec);
    const all = $('[data-ptabs-all]', sec);
    const limit = Number(sec.dataset.limit || 12);
    const onlyStock = sec.dataset.stock === 'true';
    let token = 0;
    async function show(btn) {
      const RF = window.RiftFinder;
      if (!RF || !btn) return;
      $$('[data-ptab]', sec).forEach((b) => { const on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); });
      if (all) {
        const u = new URL(all.href, window.location.origin);
        if (btn.dataset.game) u.searchParams.set('game', btn.dataset.game); else u.searchParams.delete('game');
        all.href = u.pathname + u.search;
      }
      const my = ++token;
      row.classList.add('is-loading');
      try {
        let items = await RF.fetchFeed(btn.dataset.ptab, { sort: sec.dataset.sort, maxPages: 1 });
        if (my !== token) return;
        if (onlyStock) items = items.filter((it) => it.avail);
        row.innerHTML = items.slice(0, limit).map((it) => RF.cardHTML(it, { showGame: !btn.dataset.game })).join('') || '<p class="muted">Nothing here yet — check back soon.</p>';
        RF.afterCards(row);
      } catch (e) { /* keep the server-rendered cards */ }
      finally { row.classList.remove('is-loading'); }
    }
    sec.addEventListener('click', (e) => { const b = e.target.closest('[data-ptab]'); if (b) show(b); });
    const start = () => show($('[data-ptab].is-active', sec) || $('[data-ptab]', sec));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => { if (en.some((x) => x.isIntersecting)) { io.disconnect(); start(); } }, { rootMargin: '300px' });
      io.observe(sec);
    } else start();
  });

  /* ---------- recently viewed ---------- */
  const RECENT_KEY = 'recent';
  const recentData = $('script[data-recent-item]');
  if (recentData) {
    try {
      const item = JSON.parse(recentData.textContent);
      const list = store.get(RECENT_KEY, []).filter((x) => x.u !== item.u);
      list.unshift(item);
      store.set(RECENT_KEY, list.slice(0, 20));
    } catch (e) { /* ignore */ }
  }
  $$('[data-recent]').forEach((sec) => {
    const here = recentData ? JSON.parse(recentData.textContent).u : '';
    const list = store.get(RECENT_KEY, []).filter((x) => x.u !== here).slice(0, Number(sec.dataset.limit || 10));
    if (!list.length) return;
    $('[data-recent-row]', sec).innerHTML = list.map((x) => `<a class="recent__item panel" href="${escapeHtml(x.u)}">${x.i ? `<img src="${escapeHtml(x.i)}" alt="" loading="lazy">` : ''}<span class="recent__name">${escapeHtml(x.t)}</span><span class="price">${formatMoney(x.p)}</span></a>`).join('');
    sec.hidden = false;
    const clr = $('[data-recent-clear]', sec);
    if (clr) clr.addEventListener('click', () => { store.set(RECENT_KEY, []); sec.hidden = true; });
  });


  /* ---------- hero: fan of the 3 most valuable in-stock cards ---------- */
  $$('[data-hero-fan]').forEach(async (fan) => {
    const RF = window.RiftFinder;
    if (!RF || !AR.finder) return;
    try {
      const items = (await RF.fetchFeed(AR.finder.feed, { sort: 'price-descending', maxPages: 1 })).filter((it) => it.avail && it.img).slice(0, 3);
      if (items.length < 2) return;
      fan.innerHTML = items.map((it) => `<a class="hero__fan-card" href="${escapeHtml(it.url)}" tabindex="-1"><img src="${escapeHtml(it.img)}" alt=""><span class="hero__fan-price">${formatMoney(it.p)}</span></a>`).join('');
    } catch (e) { /* keep server cards */ }
  });

  /* ---------- deal of the day: auto-pick the biggest real discount ---------- */
  $$('[data-deal-auto]').forEach(async (sec) => {
    const RF = window.RiftFinder;
    if (!RF || !AR.finder) return;
    try {
      const items = await RF.loadAll();
      const deals = items.filter((it) => it.avail && it.c > it.p).sort((a, b) => (b.c - b.p) / b.c - (a.c - a.p) / a.c || b.p - a.p);
      const it = deals[0];
      if (!it) return; // no discounted products: stay hidden
      $('[data-deal-media]', sec).innerHTML = it.img ? `<a href="${escapeHtml(it.url)}" tabindex="-1"><img src="${escapeHtml(it.img)}" alt="${escapeHtml(it.name)}" loading="lazy"></a>` : '';
      const link = $('[data-deal-link]', sec); link.href = it.url; link.textContent = it.title;
      const save = Math.round((1 - it.p / it.c) * 100);
      $('[data-deal-price]', sec).innerHTML = `<span class="price">${formatMoney(it.p)}</span><s>${formatMoney(it.c)}</s><span class="badge badge--sale">Save ${save}%</span>`;
      $('[data-deal-vid]', sec).value = it.vid;
      sec.hidden = false;
    } catch (e) { /* stay hidden */ }
  });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach((root) => {
    const dataEl = $('script[data-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const form = $('form[data-product-form]', root);
    const idInput = $('input[name="id"]', form);
    const priceEl = $('[data-price]', root);
    const btn = $('[data-add-btn]', root);
    const stockEl = $('[data-stock]', root);
    const lowStock = Number(root.dataset.lowStock || 3);
    const isPreorder = root.dataset.preorder === 'true';

    function selectedOptions() {
      return $$('[data-option-index]', root).map((group) => {
        const checked = $('input:checked', group);
        return checked ? checked.value : null;
      });
    }

    function update() {
      const opts = selectedOptions();
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      // mark unavailable combos
      $$('[data-option-index]', root).forEach((group) => {
        const idx = Number(group.dataset.optionIndex);
        $$('input', group).forEach((input) => {
          const test = opts.slice(); test[idx] = input.value;
          const match = variants.find((x) => x.options.every((o, i) => o === test[i]));
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match || !match.available);
          const sub = label && label.querySelector('small');
          if (sub && match) sub.textContent = formatMoney(match.price);
        });
      });
      if (!v) {
        btn.disabled = true; btn.textContent = btn.dataset.unavailable;
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? ` <s>${formatMoney(v.compare_at_price)}</s>` : '');
      btn.disabled = !v.available;
      btn.textContent = v.available ? (isPreorder ? btn.dataset.preorder : btn.dataset.add) : btn.dataset.soldout;
      if (stockEl) {
        stockEl.classList.remove('is-low', 'is-out');
        if (!v.available) { stockEl.textContent = btn.dataset.soldout; stockEl.classList.add('is-out'); }
        else if (v.inventory_management && v.inventory_policy === 'deny' && v.inventory_quantity > 0) {
          stockEl.textContent = v.inventory_quantity + ' in stock';
          if (v.inventory_quantity <= lowStock) stockEl.classList.add('is-low');
        } else { stockEl.textContent = 'In stock'; }
      }
      const qty = $('input[name="quantity"]', form);
      if (qty && v.inventory_management && v.inventory_policy === 'deny' && v.inventory_quantity > 0) qty.max = v.inventory_quantity;
      else if (qty) qty.removeAttribute('max');
      if (v.featured_media_id) showMedia(v.featured_media_id);
      const u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u);
    }

    function showMedia(id) {
      const stageImg = $('[data-stage] img', root);
      const thumb = $(`[data-media-id="${id}"]`, root);
      if (!stageImg || !thumb) return;
      stageImg.src = thumb.dataset.full;
      stageImg.removeAttribute('srcset');
      $$('[data-media-id]', root).forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
    }

    $$('[data-option-index] input', root).forEach((i) => i.addEventListener('change', update));
    $$('[data-media-id]', root).forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.mediaId)));
    $$('[data-qty]', root).forEach((b) => b.addEventListener('click', () => {
      const input = $('input[name="quantity"]', root);
      const max = Number(input.max) || Infinity;
      input.value = Math.min(max, Math.max(1, Number(input.value || 1) + Number(b.dataset.qty)));
    }));
    update();
  });

  /* ---------- deck / list importer ---------- */
  $$('[data-deck-import]').forEach((wrap) => {
    const textarea = $('textarea', wrap);
    const parseBtn = $('[data-deck-parse]', wrap);
    const out = $('[data-deck-results]', wrap);
    const addBtn = $('[data-deck-add]', wrap);
    const totalEl = $('[data-deck-total]', wrap);
    const productCache = new Map();
    let rows = [];

    const SKIP = /^(\/\/|#|deck|main ?deck|sideboard|maybeboard|commander|companion|pok[eé]mon:?\s*\d*|trainer:?\s*\d*|energy:?\s*\d*|total cards:?\s*\d*|leader:?\s*$|characters?:?\s*\d*|events?:?\s*\d*|stages?:?\s*\d*)\s*$/i;

    function parse(text) {
      return text.split(/\r?\n/).map((l) => l.trim()).filter((l) => l && !SKIP.test(l)).map((line) => {
        const m = line.match(/^(\d+)\s*x?\s+(.+)$/i) || line.match(/^(\d+)x(\S.+)$/i);
        let qty = 1, name = line;
        if (m) { qty = Number(m[1]); name = m[2]; }
        const full = name.trim();
        // MTG Arena/MTGO "(SET) 123" and *F* flags
        let clean = full.replace(/\s*\*[A-Z]+\*\s*/g, ' ').replace(/\s*\([A-Z0-9]{2,6}\)\s*[\w-]*\s*$/i, '').trim();
        // Pokémon TCG Live "Name SET 123"
        clean = clean.replace(/\s+[A-Z]{2,4}(-[A-Z]{2})?\s+\d{1,3}[a-z]?$/, '').replace(/\s+PR-[A-Z]{2}\s+\d+$/, '').trim();
        return { qty, query: clean || full, raw: full };
      });
    }

    // Name before " [SET - NUM]" in titles like "Ryuma [OP14-EB04 - OP14-089]"
    const baseName = (t) => normText(String(t || '').split(' [')[0]);
    const codeOf = (t) => { const m = String(t || '').match(/\[([^\]]+)\]/); return m ? normText(m[1]) : ''; };

    async function search(q) {
      // 1) exact matching against the loaded catalog (fast and never fuzzy)
      const RF = window.RiftFinder;
      if (RF) {
        try {
          const items = await RF.loadAll();
          const nq = normText(q);
          const toks = nq.split(' ').filter(Boolean);
          const scored = [];
          items.forEach((it) => {
            let sc = 0;
            if (it.nameN === nq) sc = 100;
            else if (/\d/.test(nq) && it.codeN.includes(nq)) sc = 95;
            else if (/\d/.test(nq) && normText(it.num) === nq.split(' ').pop()) sc = 0;
            else if (it.nameN.startsWith(nq + ' ')) sc = 60;
            else if (toks.length > 1 && toks.every((t) => it.nameN.split(' ').includes(t))) sc = 50;
            if (sc) scored.push({ it, sc: sc + (it.avail ? 5 : 0) });
          });
          scored.sort((a, b) => b.sc - a.sc || a.it.p - b.it.p);
          return scored.slice(0, 12).map(({ it }) => ({ title: it.title + (it.print && it.print !== 'Normal' ? ` (${it.print})` : '') + ` — ${RF.money(it.p)}`, url: it.url, available: it.avail }));
        } catch (err) { /* fall through to Shopify search */ }
      }
      const params = new URLSearchParams({
        q,
        'resources[type]': 'product',
        'resources[limit]': '10',
        'resources[options][fields]': 'title,variants.sku,tag',
        'resources[options][unavailable_products]': 'last'
      });
      const res = await fetch((AR.routes.predictive_search || root + '/search/suggest') + '.json?' + params);
      const data = await res.json();
      const prods = (data.resources && data.resources.results && data.resources.results.products) || [];
      // Shopify returns loose "related" matches (Gundam -> Gum-Gum). Keep real matches only, best first.
      const nq = normText(q);
      const toks = nq.split(' ').filter(Boolean);
      const scored = prods.map((p) => {
        const name = baseName(p.title), code = codeOf(p.title);
        const hay = name + ' ' + code + ' ' + normText((p.variants || []).map((v) => v.sku).join(' '));
        let score = -1;
        if (name === nq) score = 100;
        else if (code && (code.includes(nq) || nq.includes(code.split(' ').pop()))) score = 90;
        else if (name.startsWith(nq)) score = 70;
        else if (toks.every((t) => hay.includes(t))) score = 50;
        if (p.available) score += 5;
        return { p, score };
      }).filter((x) => x.score >= 50).sort((a, b) => b.score - a.score);
      return scored.map((x) => x.p);
    }

    async function getProduct(url) {
      const handle = url.split('/products/')[1].split(/[?#]/)[0];
      if (productCache.has(handle)) return productCache.get(handle);
      const res = await fetch(root + '/products/' + handle + '.js');
      const p = await res.json();
      productCache.set(handle, p);
      return p;
    }

    function cheapestAvailable(p) {
      const avail = p.variants.filter((v) => v.available);
      return (avail.length ? avail : p.variants).slice().sort((a, b) => a.price - b.price)[0];
    }

    async function pool(items, size, fn) {
      const results = []; let i = 0;
      const workers = Array.from({ length: Math.min(size, items.length) }, async () => {
        while (i < items.length) { const idx = i++; results[idx] = await fn(items[idx], idx); }
      });
      await Promise.all(workers);
      return results;
    }

    function renderRow(row, idx) {
      const el = document.createElement('div');
      el.className = 'deck-row' + (row.matches.length ? '' : ' deck-row--missing');
      if (!row.matches.length) {
        el.innerHTML = `<span class="deck-row__qty">${row.qty}</span><div><div class="deck-row__name">${escapeHtml(row.raw)}</div><div class="deck-row__status muted">Not found in store</div></div><span></span>`;
        return el;
      }
      const productOpts = row.matches.map((m, i) => `<option value="${i}">${escapeHtml(m.title)}</option>`).join('');
      el.innerHTML = `
        <span class="deck-row__qty">${row.qty}</span>
        <div>
          <div class="deck-row__name" style="font-weight:600">${escapeHtml(row.raw)}</div>
          <div style="display:flex;gap:.4rem;flex-wrap:wrap;margin-top:.35rem">
            <select class="select" data-pick-product="${idx}" aria-label="Matching product">${productOpts}</select>
            <select class="select" data-pick-variant="${idx}" aria-label="Condition / version"></select>
          </div>
          <div class="deck-row__status" data-status="${idx}"></div>
        </div>
        <label style="font-size:.8rem;display:flex;gap:.3rem;align-items:center"><input type="checkbox" data-include="${idx}" checked> Add</label>`;
      return el;
    }

    async function fillVariants(idx) {
      const row = rows[idx];
      const sel = $(`[data-pick-variant="${idx}"]`, out);
      const status = $(`[data-status="${idx}"]`, out);
      if (!sel) return;
      const p = await getProduct(row.matches[row.productIndex].url);
      row.product = p;
      const best = cheapestAvailable(p);
      sel.innerHTML = p.variants.map((v) => `<option value="${v.id}" ${v.id === best.id ? 'selected' : ''} ${v.available ? '' : 'disabled'}>${escapeHtml(v.title === 'Default Title' ? 'Standard' : v.title)} — ${formatMoney(v.price)}${v.available ? '' : ' (sold out)'}</option>`).join('');
      row.variantId = best.available ? best.id : null;
      status.innerHTML = best.available ? '<span style="color:var(--c-success)">Available</span>' : '<span style="color:var(--c-sale)">Sold out</span>';
      updateTotal();
    }

    function updateTotal() {
      let total = 0, count = 0;
      rows.forEach((row, idx) => {
        const inc = $(`[data-include="${idx}"]`, out);
        if (!row.product || !row.variantId || (inc && !inc.checked)) return;
        const v = row.product.variants.find((x) => x.id === row.variantId);
        if (v) { total += v.price * row.qty; count += row.qty; }
      });
      if (totalEl) totalEl.textContent = `${count} cards · ${formatMoney(total)}`;
      if (addBtn) addBtn.disabled = count === 0;
    }

    parseBtn && parseBtn.addEventListener('click', async () => {
      const parsed = parse(textarea.value);
      if (!parsed.length) { toast('Paste a decklist first', true); return; }
      out.innerHTML = '<p class="muted">Searching the vault…</p>';
      parseBtn.disabled = true;
      try {
        rows = await pool(parsed, 4, async (row) => {
          let matches = await search(row.query);
          if (!matches.length && row.query !== row.raw) matches = await search(row.raw);
          return Object.assign(row, { matches, productIndex: 0, variantId: null, product: null });
        });
        out.innerHTML = '';
        rows.forEach((row, idx) => out.appendChild(renderRow(row, idx)));
        await pool(rows.map((_, i) => i).filter((i) => rows[i].matches.length), 4, fillVariants);
        const missing = rows.filter((r) => !r.matches.length).length;
        if (missing) toast(`${missing} card${missing > 1 ? 's' : ''} not found`, true);
      } catch (e) {
        out.innerHTML = '<p class="muted">Search failed. Please try again.</p>';
      } finally {
        parseBtn.disabled = false;
        updateTotal();
      }
    });

    out && out.addEventListener('change', async (e) => {
      const pp = e.target.closest('[data-pick-product]');
      const pv = e.target.closest('[data-pick-variant]');
      if (pp) { const idx = Number(pp.dataset.pickProduct); rows[idx].productIndex = Number(pp.value); await fillVariants(idx); }
      if (pv) { rows[Number(pv.dataset.pickVariant)].variantId = Number(pv.value); }
      updateTotal();
    });

    addBtn && addBtn.addEventListener('click', async () => {
      const items = [];
      rows.forEach((row, idx) => {
        const inc = $(`[data-include="${idx}"]`, out);
        if (row.variantId && (!inc || inc.checked)) items.push({ id: row.variantId, quantity: row.qty });
      });
      if (!items.length) return;
      addBtn.disabled = true;
      try {
        await addToCart(items);
        toast(`Added ${items.reduce((s, i) => s + i.quantity, 0)} cards to cart`);
      } catch (err) {
        // fall back to one-by-one so one short-stocked card doesn't block the rest
        let ok = 0; const failed = [];
        for (const item of items) {
          try { await addToCart([item]); ok += item.quantity; } catch (e2) { failed.push(item.id); }
        }
        toast(`Added ${ok} cards${failed.length ? `, ${failed.length} line(s) short on stock` : ''}`, failed.length > 0);
      } finally { addBtn.disabled = false; }
    });
  });
})();
